import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getArticles } from '@/lib/articlesApi';
import { InterviewMapperService } from '@/services/interview/management/base/interviewMapperService';

export const usePaginatedPublishHistory = (itemsPerPage: number = 50) => {
  const [page, setPage] = useState(1);
  
  const {
    data: publishedInterviews,
    isLoading,
    error
  } = useQuery({
    queryKey: ['publishedInterviews', 'paginated', page, itemsPerPage],
    queryFn: async () => {
      const offset = (page - 1) * itemsPerPage;
      const data = await getArticles({ 
        limit: itemsPerPage, 
        offset 
      });
      
      if (!data || !Array.isArray(data)) {
        return [];
      }
      
      return data.map(interview => 
        InterviewMapperService.mapDatabaseInterviewToModel(interview as any)
      );
    },
    staleTime: 0,
    refetchOnWindowFocus: false,
  });

  return {
    publishedInterviews,
    isLoading,
    error,
    page,
    setPage,
    itemsPerPage
  };
};
